import React, { useState, useEffect, useRef, Children } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ImageChecker from "../../Generic/ImageChecker";

import ProductQuickStats from "../ProductQuickStats";
import ProductLogExport from "./ProductLogExport";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  Switch,
  TimePicker,
  Checkbox,
  message,
  Typography,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
  searchData,
} from "../../../Redux/actions/crudActions";
import { errorParser, numberWithCommas } from "../../../utils/helpers";
import {
  getInBranchItems,
  setMonthlyInventory,
  updateMonthlyInventory,
} from "../../../Redux/actions/monthlyInventoryActions";

import { getProduct } from "../../../Redux/actions/productActions";
import {
  setProductInventory,
  setProductInventoryWithLocation,
} from "../../../Redux/actions/inventoryActions";
import {
  getWeightedExchangeRate,
  calculateWeightedExchangeRate,
} from "../../../Redux/actions/exchangerateActions";
import {
  getProductSpecificInventoryWithLocation,
  updateOrSaveInventoryWithAuditField,
} from "../../../Redux/actions/inventoryActions";

import ProductBranchLogTable from "../ProductBranchLogTable";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;
const { Text } = Typography;

const Index = ({ display, thisItem, branch, onOpenProduct }) => {
  const dispatch = useDispatch();
  const { branchitems, user } = useSelector(
    (state) => ({
      branchitems: state.monthlyInventory.branchitems,
      user: state.auth.user,
    }),
    shallowEqual
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [excludeFromAudit, setExcudeFromAudit] = useState(false);
  const [childData, setChildData] = useState([]);

  useEffect(() => {
    // if(isModalVisible ){
    //   getInventorydata()
    // }
  }, [thisItem, isModalVisible]);

  const getInventorydata = async () => {
    setLoading(true);
    var newdata = await dispatch(
      getProductSpecificInventoryWithLocation(thisItem, branch)
    );
    console.log("getInventorydata", newdata);
    var currentexcludeFromAudit = false;
    if (newdata?.excludeFromAudit && newdata?.excludeFromAudit == true) {
      currentexcludeFromAudit = true;
    }
    setExcudeFromAudit(currentexcludeFromAudit);
    setLoading(false);
  };

  const includeExcludefromAudit = async (e) => {
    setLoading(true);
    const success = await dispatch(
      updateOrSaveInventoryWithAuditField(thisItem, branch, e)
    );
    if (success) {
      console.log("Update/Create successful");
    } else {
      console.log("Update/Create failed");
    }
    setExcudeFromAudit(e);
    setLoading(false);
  };

  const closeModal = (action) => {
    setIsModalVisible(false);
  };

  const handleFromChild = (data) => {
    console.log("dataaa", data);
    setChildData(data);
  };

  const handleOpenProduct = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (typeof onOpenProduct === "function") {
      onOpenProduct(thisItem);
    }
  };

  return (
    <>
      <div className={""}>
        <Button
          type="link"
          size="small"
          className="inventory-log-trigger"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            setIsModalVisible(true);
            setLoading(false);
          }}
        >
          <Text>{display}</Text>
        </Button>
      </div>

      {isModalVisible ? (
        <Modal
          title={
            <div className="inventory-log-modal-title">
              {typeof onOpenProduct === "function" ? (
                <Button
                  type="link"
                  className="inventory-log-product-link"
                  onClick={handleOpenProduct}
                >
                  {thisItem.name}
                </Button>
              ) : (
                <span>{thisItem.name}</span>
              )}
              <span className="inventory-log-branch-label">- {branch.name}</span>
            </div>
          }
          footer={false}
          visible={isModalVisible}
          className={"minwidthis50 nopadding"}
          onCancel={() => {
            closeModal();
          }}
          bodyStyle={{ padding: "0px" }}
        >
          <div className="logmodal-content">
            {/* <div>
              {(user.role =='admin'|| user.role =='manager')?
                <Switch checkedChildren="include in audit" unCheckedChildren="not included in audit"  checked={!excludeFromAudit}
                  loading={loading}
                  onChange={e=>{includeExcludefromAudit(!e)}}
                  />
                :null
              }
              </div> */}

            <ProductQuickStats
              branchID={branch.id}
              productID={thisItem.id}
              product={thisItem}
              displayType={1}
            />
            <ProductLogExport
              values={childData}
              name={`${thisItem.name} - ${branch.name}`}
            />

            <h3>Inventory Log</h3>
            <ProductBranchLogTable
              branchID={branch.id}
              productID={thisItem.id}
              product={thisItem}
              onSendData={handleFromChild}
            />
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
